import HeroSection from "./HeroSection";
import HrGardenSection from "./WhatIsHrGarden";
import EthosSection from "./EthosSection";
import ModulesSection from "./ModulesSection";
import WhatIsHrGarden from "./WhatIsHrGarden";
import WebsiteForm from "./WebsiteForm";
import styled from "@emotion/styled";
import { Box } from "@theme-ui/components";
import { typography } from "../../styles/theme";

const { fontFamily, fontSize, fontStyle, fontWeight, lineHeight } =
  typography.textMd400;
const StyledDescription = styled(Box)`
  line-height: ${lineHeight};
  font-family: ${fontFamily};
  font-size: ${fontSize};
  font-style: ${fontStyle};
  font-weight: ${fontWeight};
  line-height: ${lineHeight};
`;

export {
  HeroSection,
  HrGardenSection,
  EthosSection,
  ModulesSection,
  WebsiteForm,
  WhatIsHrGarden,
  StyledDescription,
};
